import { get, set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import SEARCH_CONTEXT from '../../../../../helpers/OutreachSearchContext';
import {
  onChangeQuery,
  onClearQuery
} from '../../../actions/components/search';

const defaultQuery = { q: '' };

const initialState = {
  byContext: {
    [SEARCH_CONTEXT.OUTREACH]: { query: defaultQuery }
  }
};

const onChangeQueryHandler = action => ({
  [action.toString()]: (state, { payload: { context, query } }) => {
    const contextQuery = get(`byContext.${context}.query`, state);
    return set(
      `byContext.${context}.query`,
      { ...contextQuery, ...query },
      state
    );
  }
});

const onClearQueryHandler = action => ({
  [action.toString()]: (state, { payload: { context } }) =>
    set(`byContext.${context}.query`, defaultQuery, state)
});

export default createReducer(initialState, {
  ...onChangeQueryHandler(onChangeQuery),
  ...onClearQueryHandler(onClearQuery)
});
